import React from "react";

export interface ITaskContext {
  abilities: Array<string>;
}
export const AbitlityContext = React.createContext<ITaskContext>(null);

export default AbitlityContext;
